import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { brl } from "@/lib/api";
import { Surface } from "@/components/ds";

const Item = ({ label, value, tone, testid }) => (
  <div data-testid={testid}>
    <p className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <p className={`mt-1 font-num text-lg font-semibold ${tone || ""}`}>{value}</p>
  </div>
);

export function DashboardFinance({ finance }) {
  if (!finance) return null;
  const max = Math.max(finance.sold, finance.received, finance.receivable, 1);
  const bar = (v) => `${Math.max((v / max) * 100, 2)}%`;

  return (
    <Surface className="p-5" data-testid="dashboard-finance">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-base font-medium md:text-lg">Resumo financeiro do mês</h2>
          <p className="mt-1 text-xs text-muted-foreground">
            Vender não é receber: só o pagamento confirmado entra em Recebido.
          </p>
        </div>
        <Link
          to="/financeiro"
          data-testid="go-to-finance-overview-link"
          className="inline-flex items-center gap-1 text-xs font-medium text-brand transition-colors hover:text-brand/80"
        >
          Ver financeiro <ArrowRight className="h-3 w-3" />
        </Link>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-4 lg:grid-cols-5">
        <Item label="Vendido" value={brl(finance.sold)} testid="dash-sold" />
        <Item label="Recebido" value={brl(finance.received)} tone="text-emerald-300" testid="dash-received" />
        <Item label="A receber" value={brl(finance.receivable)} tone="text-amber-300" testid="dash-receivable" />
        <Item label="Despesas" value={brl(finance.expenses_paid)} tone="text-red-300" testid="dash-expenses" />
        <Item
          label="Resultado de caixa"
          value={brl(finance.cash_result)}
          tone={finance.cash_result >= 0 ? "text-emerald-300" : "text-red-300"}
          testid="dash-cash-result"
        />
      </div>

      <div className="mt-5 space-y-2.5">
        {[
          ["Vendido", finance.sold, "bg-primary"],
          ["Recebido", finance.received, "bg-emerald-400"],
          ["A receber", finance.receivable, "bg-amber-400"],
        ].map(([label, value, cls]) => (
          <div key={label} className="flex items-center gap-3">
            <span className="w-20 shrink-0 text-[11px] text-muted-foreground">{label}</span>
            <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/5">
              <span className={`block h-full rounded-full ${cls}`} style={{ width: bar(value) }} />
            </span>
          </div>
        ))}
      </div>
    </Surface>
  );
}
